define("checkout/components/add-ons/change", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (gt @userChange 0)}}
  
    <p data-test-id="change-positive">
      {{t (concat "plans.checkout.addons.positive_" @type "_change") amount=@userChange}}
    </p>
  {{else if (lt @userChange 0)}}
    <p class="u--text--warning" data-test-id="change-negative">
      {{t (concat "plans.checkout.addons.negative_" @type "_change") amount=(abs @userChange) date=@effectiveDate}}
    </p>
  {{/if}}
  */
  {
    "id": "zcRT/TSY",
    "block": "[[[41,[28,[37,1],[[30,1],0],null],[[[1,\"\\n  \"],[10,2],[14,\"data-test-id\",\"change-positive\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[[28,[37,3],[\"plans.checkout.addons.positive_\",[30,2],\"_change\"],null]],[[\"amount\"],[[30,1]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,4],[[30,1],0],null],[[[1,\"  \"],[10,2],[14,0,\"u--text--warning\"],[14,\"data-test-id\",\"change-negative\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[[28,[37,3],[\"plans.checkout.addons.negative_\",[30,2],\"_change\"],null]],[[\"amount\",\"date\"],[[28,[37,5],[[30,1]],null],[30,3]]]]],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[]]]],[\"@userChange\",\"@type\",\"@effectiveDate\"],false,[\"if\",\"gt\",\"t\",\"concat\",\"lt\",\"abs\"]]",
    "moduleName": "checkout/components/add-ons/change.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});